import { Device } from '@wm-front/admin/graphql'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { PillTheme } from '@wm-front/shared/common-ui'

export type DeviceState = 'working' | 'paused' | 'stopped' | 'broken'

export function getDeviceState(device?: Partial<Device>): DeviceState {
  if (device?.paused) {
    return 'paused'
  }
  if (!device?.state?.working && device?.state?.stopped) {
    return 'stopped'
  }
  if (!device?.state?.working) {
    return 'broken'
  }
  return 'working'
}

export function getDeviceStateText(state: DeviceState): string {
  switch (state) {
    case 'paused':
      return $localize`:@@getDeviceStatePaused:Paused`
    case 'stopped':
      return $localize`:@@getDeviceStateStopped:Shutdown`
    case 'broken':
      return $localize`:@@getDeviceStateBroken:Breakdown`
    case 'working':
      return $localize`:@@getDeviceStateWorking:In service`
  }
}

export function getDeviceStateTheme(state: DeviceState): PillTheme {
  switch (state) {
    case 'paused':
      return 'sky'
    case 'stopped':
      return 'danger'
    case 'broken':
      return 'warning'
    case 'working':
      return 'success'
  }
}
